import moment from "moment";

export const HOME_ACTION = "HOME_ACTION";
export const SUMMERY_ACTION = 'SUMMERY_ACTION';
export const SELF_SUMMARY_ACTION = 'SELF_SUMMARY_ACTION';
export const SUMMERY_UPDATE_ACTION = 'SUMMERY_UPDATE_ACTION';
export const HISTORY_ACTION = 'HISTORY_ACTION';
export const GET_INVITATION_INFO_ACTION = "GET_INVITATION_INFO_ACTION";
export const LOCATION_ACTION = "LOCATION_ACTION";
export const LOGOUT = "LOGOUT";
export const CREATE_REPORT_ACTION="CREATE_REPORT_ACTION";
export const GET_REPORT_ACTION="GET_REPORT_ACTION";
export const DELETE_REPORT_ACTION="DELETE_REPORT_ACTION";
export const REMOVE_CONNECTION_ACTION = "REMOVE_CONNECTION_ACTION";
export const CLEAN_SUMMARY_DATA_ACTION = "CLEAN_SUMMARY_DATA_ACTION";
export const GET_CONFIG_ACTION = "GET_CONFIG_ACTION";

export const DEFAULT_PARAMETERS = {
    defaultDailyTime: moment(new Date()).set({
      hour: parseInt(18),
      minute: parseInt(0),
    }).toDate(),
  
  };